import React from "react";

export const EmailIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none">
        <path
          d="M4.5 20.5C3.95 20.5 3.47933 20.3043 3.088 19.913C2.69667 19.5217 2.50067 19.0507 2.5 18.5V6.5C2.5 5.95 2.696 5.47933 3.088 5.088C3.48 4.69667 3.95067 4.50067 4.5 4.5H20.5C21.05 4.5 21.521 4.696 21.913 5.088C22.305 5.48 22.5007 5.95067 22.5 6.5V18.5C22.5 19.05 22.3043 19.521 21.913 19.913C21.5217 20.305 21.0507 20.5007 20.5 20.5H4.5ZM12.5 13.5L4.5 8.5V18.5H20.5V8.5L12.5 13.5ZM12.5 11.5L20.5 6.5H4.5L12.5 11.5ZM4.5 8.5V6.5V18.5V8.5Z"
          fill="#005585"
        />
      </svg>
    </div>
  );
};
